import { render, staticRenderFns } from "./jinchu.vue?vue&type=template&id=92f2d288&scoped=true&"
import script from "./jinchu.vue?vue&type=script&lang=js&"
export * from "./jinchu.vue?vue&type=script&lang=js&"
import style0 from "./jinchu.vue?vue&type=style&index=0&id=92f2d288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f2d288",
  null
  
)

export default component.exports